import axios from 'axios';
import { Esteira } from '../interfaces/Esteira';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const authHeader = (): Record<string, string> => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export async function getEsteiras(includeInactive = false): Promise<Esteira[]> {
  const response = await axios.get(`${BACKEND_URL}/esteiras`, {
    params: { includeInactive },
    headers: authHeader(),
    withCredentials: true,
  });
  return response.data;
}

export async function getEsteiraById(id: string): Promise<Esteira> {
  const response = await axios.get(`${BACKEND_URL}/esteiras/${id}`, {
    headers: authHeader(),
    withCredentials: true,
  });
  return response.data;
}

export async function createEsteira(data: Partial<Esteira>): Promise<Esteira> {
  const response = await axios.post(`${BACKEND_URL}/esteiras`, data, {
    headers: authHeader(),
    withCredentials: true,
  });
  return response.data;
}

export async function updateEsteira(id: string, data: Partial<Esteira>): Promise<Esteira> {
  const response = await axios.patch(`${BACKEND_URL}/esteiras/${id}`, data, {
    headers: authHeader(),
    withCredentials: true,
  });
  return response.data;
}

export async function deleteEsteira(id: string): Promise<void> {
  await axios.delete(`${BACKEND_URL}/esteiras/${id}`, {
    headers: authHeader(),
    withCredentials: true,
  });
}
